import { DailyEarningsChart } from "../DailyEarningsChart";
import { MonthlyEarningsChart } from "../MonthlyEarningsChart";
import { OrderDashbordDay } from "../OrderDashbordDay";
import { OrderMonthlyLineChart } from "../OrderMonthlyLineChart";
 import OrderStatusChartAmount from "../OrderStatusChartAmount";
 import { Box, Typography, Grid, Paper, CircularProgress } from '@mui/material';
import { OrderYearlyLineChart } from "../OrderYearlyLineChart";
import { YearlyEarningsChart } from "../YearlyEarningsChart";
import { getUserData } from "../../auth";
import { useGetDailyEarningsByUserIdQuery, useGetMonthlyEarningsByUserIdQuery, useGetYearlyEarningsByUserIdQuery } from "../../apis/TransactionEarningsApi";
import { useGetStatusDayTotalByUserIdQuery, useGetStatusMonthTotalByUserIdQuery, useGetStatusYearTotalByUserIdQuery } from "../../apis/CartItemApi";
 
 
const Vendordashbord = () => {
  // Your original JSON data

    // Extract user data from localStorage
    const userData = getUserData();
    const sellerId = userData?.uid ? Number(userData.uid) : 0; // Convert sellerId to a number

  // Fetch daily earnings data using the sellerId and isActive = false
// Fetch daily earnings data using the sellerId and isActive = false
 const { data: dailyEarningsDataOld, error, isLoading } = useGetDailyEarningsByUserIdQuery({ sellerId, isActive:false });
 const { data: monthlyEarningsData, isLoading:isLoadingmonthlyEarningsData } = useGetMonthlyEarningsByUserIdQuery({ sellerId, isActive:false });
 const { data: yearlyEarningsData, isLoading:isLoadingyearlyData } = useGetYearlyEarningsByUserIdQuery({ sellerId, isActive:false });
 
 const { data: data, isLoading:isLoadingData } = useGetStatusDayTotalByUserIdQuery({ sellerId, isActive:false });
 const { data: monthlyData, isLoading:isLoadingMonthlyData } = useGetStatusMonthTotalByUserIdQuery({ sellerId, isActive:false });
 const { data: yearlyData, isLoading:isLoadingYearlyData } = useGetStatusYearTotalByUserIdQuery({ sellerId, isActive:false });

 //console.log('monthlyData',monthlyData)
 //console.log('yearlyData',yearlyData)
 

  if (isLoading || isLoadingmonthlyEarningsData || isLoadingyearlyData || isLoadingData || isLoadingMonthlyData || isLoadingYearlyData) return (
    <div className="flex-center py-20" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
       <CircularProgress sx={{ color: '#FFA500' }} /> {/* Hex code for orange */}    </div>
); 
if (error) return <div>Error: {error.message}</div>;

  return (
    <>

<Box sx={{ p: 3 }}>
       
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Daily Earnings</Typography>
            <DailyEarningsChart data={dailyEarningsDataOld} />
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Monthly Earnings</Typography>
            <MonthlyEarningsChart data={monthlyEarningsData} />
          </Paper>
        </Grid>
        
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Yearly Earnings</Typography>
            <YearlyEarningsChart data={yearlyEarningsData} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
     <div className="dashboard">
      <OrderStatusChartAmount/>
      
      <OrderDashbordDay data={data} />
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
             <OrderMonthlyLineChart data={monthlyData} />
         </Grid>
        
        <Grid item xs={12} md={6}>
 
            <OrderYearlyLineChart data={yearlyData} />         
         </Grid>
         
      </Grid>
    </div>
    
    </>
   
    
  );

};

export default Vendordashbord;